import { ProjectType } from 'magma/common/interfaces';
import { ID } from 'server/dao/types';

export enum PostType {
  // Drawing = 'drawing',
  // Directory = 'directory',
  Link = 'link',
  Video = 'video',
  Article = 'article',
}

export interface Post {
  _id: string;
  type: PostType;
  project: string; // id of project in which post exist within
  url: string; // url to post itself
  thumbnail: string; // url to thumbnail
  title: string; // title below entity thumbnail in grid view
  description: string; // markdown description visible in modal
  order: number;
  createdAt: string;
}

export interface CreatePostData {
  type: PostType;
  project: ID;
  url?: string;
  thumbnail?: string;
  title: string;
  description?: string;
}

export type UpdatePostData = Omit<Partial<Post>, 'project' | 'type'>;

export const COMMUNITY_HUB_TEAM_ID = 'e07f1d11c5e0f34e04cef85c';
export const COMMUNITY_HUB_TEAM_NAME = 'Community Hub';
export const BASE_COMMUNITY_HUB_PROJECT = {
  team: COMMUNITY_HUB_TEAM_ID,
  type: ProjectType.ContentPage,
};
